import React from 'react';
import { useFormContext } from '../context/FormContext';
import PillGroup from './PillGroup';
import { useTranslation } from "react-i18next";

/**
 * SmartPillGroup - Context-aware PillGroup
 * @param {Object} props
 * @param {string} props.name - Field name
 * @param {Array} props.options - Options for PillGroup
 * @param {boolean} props.multiple - Allow multiple selection
 */
export const SmartPillGroup = ({ name, options, multiple = false, label, ...props }) => {
    const { formData, errors, handleFieldChange, registerLabel, unregisterLabel } = useFormContext();
    const { t } = useTranslation();
    React.useEffect(() => {
        if (label) {
            registerLabel(name, label);
        }
        return () => {
            unregisterLabel(name);
        };
    }, [name, label, registerLabel, unregisterLabel]);

    const selected = formData[name] || (multiple ? [] : '');
    const error = errors[name];

    const onSelect = (value) => {
        handleFieldChange(name, value);
    };

    return (
        <div className="flex flex-col gap-1">
            <PillGroup
                options={options}
                selected={selected}
                onSelect={onSelect}
                multiple={multiple}
                {...props}
            />
            {error && <span className="text-red-500 text-xs">{t(error)}</span>}
        </div>
    );
};

export default SmartPillGroup;
